import { FunctionalComponentOptions } from 'vue/types';

export default (value: string): FunctionalComponentOptions => ({
  functional: true,
  render(createElement) {
    return createElement('span', value);
  },
});
